import Dashboard from './Dashboard.page';

export default Dashboard;
